// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8566c149","453":"26d25476","455":"46257d2a","977":"5ed00909"}[chunkId] + ".chunk.js";
};